(function () {
  const STORAGE_KEY = 'far-afield-wishlist';

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem(STORAGE_KEY)) || [];
    } catch (error) {
      return [];
    }
  }

  function saveWishlist(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }

  function findItem(productId) {
    return getWishlist().find((item) => String(item.id) === String(productId));
  }

  function addItem(product) {
    const wishlist = getWishlist();
    const exists = wishlist.some((item) => String(item.id) === String(product.id));

    if (!exists) {
      wishlist.push(product);
      saveWishlist(wishlist);
    }
  }

  function removeItem(productId) {
    const wishlist = getWishlist().filter((item) => String(item.id) !== String(productId));
    saveWishlist(wishlist);
  }

  function updateButtonState(button) {
    const productId = button.dataset.productId;
    const isInWishlist = Boolean(findItem(productId));

    button.classList.toggle('is-active', isInWishlist);
    button.setAttribute('aria-pressed', isInWishlist ? 'true' : 'false');

    const title = button.dataset.productTitle || 'this product';

    button.setAttribute(
      'aria-label',
      isInWishlist ? `Remove ${title} from wishlist` : `Add ${title} to wishlist`
    );
  }

  function updateAllButtons() {
    document.querySelectorAll('.js-wishlist-button').forEach(updateButtonState);
  }

  function productFromButton(button) {
    return {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: button.dataset.productPrice
    };
  }

  function handleButtonClick(event) {
    const button = event.target.closest('.js-wishlist-button');

    if (!button) return;

    const product = productFromButton(button);
    const exists = Boolean(findItem(product.id));

    if (exists) {
      removeItem(product.id);
    } else {
      addItem(product);
    }

    updateAllButtons();
    renderWishlistPage();
  }

  function renderWishlistPage() {
    const grid = document.querySelector('.js-wishlist-grid');
    const emptyState = document.querySelector('.js-wishlist-empty');

    if (!grid) return;

    const wishlist = getWishlist();

    grid.innerHTML = '';

    if (!wishlist.length) {
      if (emptyState) emptyState.hidden = false;
      grid.hidden = true;
      return;
    }

    if (emptyState) emptyState.hidden = true;
    grid.hidden = false;

    wishlist.forEach((item) => {
      const card = document.createElement('article');
      card.className = 'wishlist-card';

      const imageHtml = item.image
        ? `
          <a href="${item.url}" class="wishlist-card__image-link">
            <img src="${item.image}" alt="${item.title}" loading="lazy" class="wishlist-card__image">
          </a>
        `
        : '';

      card.innerHTML = `
  ${imageHtml}

  <div class="wishlist-card__content">
    <div class="wishlist-card__title-row">
      <h2 class="wishlist-card__title">
        <a href="${item.url}">${item.title}</a>
      </h2>

      <button
        type="button"
        class="wishlist-card__remove js-wishlist-remove"
        data-product-id="${item.id}"
        aria-label="Remove ${item.title} from wishlist"
      >
        Remove
      </button>
    </div>

    <p class="wishlist-card__price">${item.price || ''}</p>
  </div>
`;

      grid.appendChild(card);
    });
  }

  function handleRemoveClick(event) {
    const button = event.target.closest('.js-wishlist-remove');

    if (!button) return;

    removeItem(button.dataset.productId);
    updateAllButtons();
    renderWishlistPage();
  }

  document.addEventListener('click', handleButtonClick);
  document.addEventListener('click', handleRemoveClick);

  document.addEventListener('DOMContentLoaded', function () {
    updateAllButtons();
    renderWishlistPage();
  });

  document.addEventListener('shopify:section:load', function () {
    updateAllButtons();
    renderWishlistPage();
  });
})();